(() => {
  'use strict';

  function initializeProduct(section) {
    if (section.dataset.commerceReady === 'true') return;
    const select = section.querySelector('[data-variant-select]');
    const form = section.querySelector('[data-product-form]');
    if (!select || !form) return;
    section.dataset.commerceReady = 'true';
    const quantity = form.querySelector('[data-product-quantity]');
    const planSelect = form.querySelector('[data-selling-plan]');
    const planAllocations = [...form.querySelectorAll('[data-plan-id]')];
    const addButton = form.querySelector('[data-add-to-cart]');

    function update({ updateUrl = false, variantChanged = false } = {}) {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const singleVariant = form.querySelector('[data-single-variant]');
      if (singleVariant) singleVariant.value = option.value;
      let allocation;
      let planAvailable = true;

      if (planSelect) {
        for (const plan of planSelect.options) {
          plan.disabled = Boolean(plan.value) && !planAllocations.some(
            entry => entry.dataset.variantId === option.value && entry.dataset.planId === plan.value
          );
        }
        if (variantChanged && planSelect.selectedOptions[0]?.disabled) {
          const firstAvailable = [...planSelect.options].find(plan => !plan.disabled);
          planSelect.value = firstAvailable?.value || '';
        }
        if (planSelect.value) {
          allocation = planAllocations.find(
            entry => entry.dataset.variantId === option.value && entry.dataset.planId === planSelect.value
          );
          planAvailable = Boolean(allocation);
        } else if (planSelect.required) {
          planAvailable = false;
        }
      }

      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const unit = section.querySelector('[data-unit-price]');
      const availability = section.querySelector('[data-product-availability]');
      if (price) price.textContent = allocation?.dataset.price || option.dataset.price || '';
      const compareText = allocation ? allocation.dataset.compare : option.dataset.compare;
      if (compare) {
        compare.textContent = compareText || '';
        compare.hidden = !compareText;
      }
      if (unit) {
        unit.textContent = option.dataset.unit || '';
        // A selling plan may have a different unit price. Avoid showing the one-time unit price.
        unit.hidden = !option.dataset.unit || Boolean(allocation);
      }
      if (availability) availability.textContent = !available ? 'Sold out' : !planAvailable ? 'Unavailable for this purchase option' : 'Available';
      if (addButton) {
        addButton.disabled = !available || !planAvailable;
        addButton.textContent = !available ? 'Sold out' : !planAvailable ? 'Unavailable' : 'Add to cart';
      }
      const express = section.querySelector('[data-dynamic-checkout]');
      if (express) express.hidden = !available || !planAvailable;

      if (quantity) {
        const min = Number(option.dataset.min) || 1;
        const step = Number(option.dataset.step) || 1;
        const max = Number(option.dataset.max) || null;
        quantity.min = String(min);
        quantity.step = String(step);
        if (max !== null) quantity.max = String(max);
        else quantity.removeAttribute('max');
        if (variantChanged) quantity.value = String(min);
        const rules = [];
        if (min > 1) rules.push(`Minimum ${min}`);
        if (step > 1) rules.push(`Increments of ${step}`);
        if (max !== null) rules.push(`Maximum ${max}`);
        const ruleText = form.querySelector('[data-quantity-rule]');
        if (ruleText) {
          ruleText.textContent = rules.join(' · ');
          ruleText.hidden = rules.length === 0;
        }
      }

      const gallery = section.querySelector('[data-product-gallery]');
      const media = [...section.querySelectorAll('[data-product-media-id]')].find(
        entry => entry.dataset.productMediaId === option.dataset.mediaId
      );
      if (gallery && media && gallery.firstElementChild !== media) {
        gallery.querySelectorAll('video').forEach(video => video.pause());
        gallery.prepend(media);
      }
      if (updateUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        url.searchParams.delete('option_values');
        window.history.replaceState({}, '', url.toString());
      }
    }

    select.addEventListener('change', () => update({ updateUrl: true, variantChanged: true }));
    planSelect?.addEventListener('change', () => update());
    update({ variantChanged: true });
  }

  function initialize(root = document) {
    if (root.matches?.('[data-product-section]')) initializeProduct(root);
    root.querySelectorAll('[data-product-section]').forEach(initializeProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
